<!-- <app-header [headerInit]="headerInit"></app-header> -->

<ion-header>
  <ion-toolbar>
    <ion-title>legal</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>

</ion-content>
